import React from 'react';
import Footer from '../../../layout/Footer/Footer';
import '../../../components/dashboard/transfer-market/transfer-market.css';

const SITE = 'https://victorycup.ro';
const VERSION = '1.5.0';

// Paginile publice de pe site (landing-page) utile din aplicatie
const LINKS = [
    {label: 'Program', path: '/program'},
    {label: 'Rezultate', path: '/rezultate'},
    {label: 'Întrebări', path: '/intrebari-si-raspunsuri'},
    {label: 'Contact', path: '/contact'},
];

// Footer-ul aplicatiei in designul Transfer market 2.0, pereche cu DefaultHeader: copyright + versiune in stanga, linkuri spre site in dreapta
const DefaultFooter = () => {
    const user = JSON.parse(`${localStorage.getItem('user')}`);
    if (!user?.token) return null;

    return (
        <Footer>
            <div className='vtm-ftr'>
                <div className='vtm-ftr-left'>
                    <span className='vtm-ftr-copy'>© {new Date().getFullYear()} Victory Cup</span>
                    <span className='vtm-ftr-ver' title='Versiunea aplicației'>v{VERSION}</span>
                </div>
                <nav className='vtm-ftr-links' aria-label='Linkuri Victory Cup'>
                    {LINKS.map(link => (
                        <a key={link.path} className='vtm-ftr-link vtm-ftr-link--page' href={`${SITE}${link.path}`} target='_blank' rel='noopener noreferrer'>
                            {link.label}
                        </a>
                    ))}
                    <a className='vtm-ftr-link vtm-ftr-link--site' href={SITE} target='_blank' rel='noopener noreferrer'>
                        victorycup.ro
                        <svg width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.6' aria-hidden='true'>
                            <path d='M7 17 17 7M9 7h8v8'/>
                        </svg>
                    </a>
                </nav>
            </div>
        </Footer>
    );
};

export default DefaultFooter;
